import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement } from 'react';
import styled from 'styled-components';
import { Box, Container, Tiles, breakpoint, mb, px } from '@nib/layout';
import Heading from '@nib-components/heading';
import Feature from './Feature';
const BoxWrapper = styled(Box)`
  box-sizing: border-box;
  ${px({
  xs: 0,
  sm: 5
})};
`;
export const FeaturePanelTitle = styled(Heading)`
  text-align: center;
  ${mb(3)};

  ${breakpoint('md')`
    ${mb(6)};
  `};
`;
const FeaturePanel = props => {
  const {
    title,
    titleComponent = 'h2',
    containerWidth,
    displayIcons = true,
    children,
    space = 0,
    iconFill,
    iconAccentFill,
    ...otherProps
  } = props;
  const featureCount = Children.count(children);
  //warn the user if they provide not-enough or too many features
  if (process.env.NODE_ENV !== 'production') {
    const invariant = require('invariant');
    invariant(featureCount >= 2 || featureCount <= 4, '@nib-components/feature-panel: Must have 2-4 features.');
  }
  const featureSize = () => {
    if (featureCount === 1) {
      return 1;
    } else if (featureCount === 2 || featureCount === 4) {
      return 2;
    } else {
      return 3;
    }
  };
  const columns = props.columns || {
    xs: 1,
    lg: featureSize()
  };
  const panelTitle = title && /*#__PURE__*/_jsx(FeaturePanelTitle, {
    component: titleComponent,
    size: {
      xs: 3,
      md: 2
    },
    children: title
  });
  return /*#__PURE__*/_jsx(Box, {
    "data-mesh-component": "FEATURE-PANEL",
    paddingVertical: {
      xs: 6,
      sm: 8
    },
    paddingHorizontal: {
      xs: 4,
      sm: 5
    },
    ...otherProps,
    children: /*#__PURE__*/_jsxs(Container, {
      width: containerWidth,
      children: [panelTitle, /*#__PURE__*/_jsx(Tiles, {
        space: space,
        columns: columns,
        children: Children.map(props.children, (child // eslint-disable-line  @typescript-eslint/no-explicit-any
        ) => /*#__PURE__*/_jsx(BoxWrapper, {
          padding: 5,
          paddingVertical: {
            lg: 6
          },
          height: "100%",
          children: /*#__PURE__*/cloneElement(child, {
            displayIcons,
            iconFill,
            iconAccentFill
          })
        }))
      })]
    })
  });
};
FeaturePanel.displayName = 'FeaturePanel';
FeaturePanel.Feature = Feature;
export default FeaturePanel;